import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import JsonEditor from "../Common/JsonEditor";
import { CommonType } from "../../types";

type PayloadInputSectionProps = {
  payloadText: string;
  selectedParserConfig: number | "";
  parserConfigList: CommonType[];
  onPayloadChange: (value: string) => void;
  onParserConfigChange: (parserConfigId: number) => void;
  onParse: () => void;
  onError?: (error: Error) => void;
  disabled?: boolean;
};

const PayloadInputSection: React.FC<PayloadInputSectionProps> = ({
  payloadText,
  selectedParserConfig,
  parserConfigList,
  onPayloadChange,
  onParserConfigChange,
  onParse,
  onError,
  disabled = false,
}) => {
  const handleParseClick = () => {
    try {
      const formatted = JSON.stringify(JSON.parse(payloadText), null, 2);
      onPayloadChange(formatted);
      onParse();
    } catch {
      onError?.(new Error("Geçersiz JSON"));
    }
  };

  return (
    <Grid
      container
      direction={"column"}
      size={{ xs: 12, md: 6 }}
      sx={{ paddingBottom: 2, paddingRight: { xs: 0, md: 2 }, minWidth: 0 }}
    >
      <Grid size={{ xs: 12 }} sx={{ minWidth: 0 }}>
        <JsonEditor value={payloadText} onChange={onPayloadChange} disabled={disabled} />
      </Grid>

      <Grid
        size={{ xs: 12 }}
        sx={{ display: "flex", justifyContent: "flex-start", pt: 3, gap: 2, width: "100%" }}
      >
        <FormControl size="small" sx={{ flex: 2 }}>
          <InputLabel id="parser-select-label">Parser Seç</InputLabel>
          <Select
            labelId="parser-select-label"
            value={selectedParserConfig}
            label="Parser Seç"
            onChange={(e) => onParserConfigChange(Number(e.target.value))}
            disabled={disabled}
          >
            {parserConfigList.map((parser) => (
              <MenuItem key={parser.id} value={parser.id}>
                {parser.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          size="medium"
          variant="outlined"
          sx={{
            flex: 1,
            px: 4,
            borderColor: "var(--color-primary)",
            color: "var(--color-primary)",
            borderRadius: "6px",
            textTransform: "none",
            "&:hover": { borderColor: "var(--color-primary-dark)", backgroundColor: "var(--color-primary-alpha-05)" },
            "&.Mui-disabled": { borderColor: "#ccc", color: "#ccc" },
          }}
          disabled={!(payloadText && selectedParserConfig) || disabled}
          onClick={handleParseClick}
        >
          {disabled ? "Parse Ediliyor..." : "Parse Et"}
        </Button>
      </Grid>
    </Grid>
  );
};

export default PayloadInputSection;
